import React from 'react';
import { TextArea } from 'semantic-ui-react';

const CustomTextArea = (props) => (
    <TextArea {...props} style={{resize: 'none'}}/>
)

export default CustomTextArea;